import clsx from 'clsx';
import { FadeIn } from 'components/common/FadeIn';
import styles from './HeadingAndSubheading.module.css';

interface HeadingAndSubheadingProps {
  heading?: string;
  subheading?: string;
  fadeInDelay?: number;
}
const HeadingAndSubheading = ({
  heading,
  subheading,
  fadeInDelay,
}: HeadingAndSubheadingProps) => {
  return (
    <FadeIn onScroll duration={0.3} delay={fadeInDelay ? fadeInDelay : 0}>
      <h3 className={clsx(styles.subheading, 'daymadeTypographyTaglineAccent')}>
        {subheading}
      </h3>
      <h2 className={clsx(styles.heading, 'daymadeTypographyMLBlack')}>
        {heading}
      </h2>
    </FadeIn>
  );
};

export default HeadingAndSubheading;
